import React from 'react'
import { Typography, Box } from '@mui/material'

export default function BrandList() {
  const brandsArray = [
    '/assets/Brands/1.png',
    '/assets/Brands/2.png',
    '/assets/Brands/3.png',
    '/assets/Brands/4.png',
    '/assets/Brands/5.png',
    '/assets/Brands/6.png',
    // '/assets/Brands/7.png',
    '/assets/Brands/13.png',
    '/assets/Brands/8.png',
    '/assets/Brands/9.png',
    '/assets/Brands/10.png',
    '/assets/Brands/11.png',
    '/assets/Brands/12.png',
  ]

  return (
    <Box justifyContent='center' textAlign='center' mt={10} px={3}>
      <Typography
        color={'#c00000'}
        fontSize={{ xs: '1.5rem', sm: '2rem' }}
        fontFamily={'GothicBold'}
      >
        BRANDS WE CARRY
      </Typography>
      <Typography
        mx={'auto'}
        mt={5}
        maxWidth={{ xs: '100%', sm: '80%' }}
        fontSize={{ xs: '1rem', sm: '1.2rem' }}
      >
        Our extensive inventory includes premium and economy brands, catering to a wide range of
        needs from Ultra High Performance and Run Flat tyres to Saloon, Economical, and Commercial
        options.
      </Typography>
      <Box
        mt={5}
        display='grid'
        gridTemplateColumns={{ xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)' }}
        rowGap={{ xs: 0, sm: 5 }}
      >
        {brandsArray.map((each, idx) => (
          <Box
            key={idx}
            height={150}
            sx={{
              backgroundImage: `url(${each})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          />
        ))}
      </Box>
    </Box>
  )
}
